import { z } from 'zod';
import { currencyCodeSchema, isoTimestampSchema, uuidSchema } from './common.js';
export const BANK_ACCOUNT_TYPE = {
    BLACK: 'black',
    WHITE: 'white',
    PLATINUM: 'platinum',
    IRON: 'iron',
    FOP: 'fop',
    YELLOW: 'yellow',
    E_AID: 'eAid',
};
export const bankAccountTypeSchema = z.enum(BANK_ACCOUNT_TYPE);
export const BANK_PROBLEM = {
    TOKEN_REJECTED: 'token_rejected',
};
export const bankProblemSchema = z.enum(BANK_PROBLEM);
const bankTokenSchema = z
    .string()
    .trim()
    .regex(/^[!-~]{20,200}$/, 'must be the token issued at api.monobank.ua');
export const connectBankBodySchema = z.object({
    token: bankTokenSchema,
});
export const bankAccountSchema = z.object({
    id: uuidSchema,
    type: bankAccountTypeSchema,
    title: z.string().min(1),
    currency: currencyCodeSchema.nullable(),
    last4: z
        .string()
        .regex(/^[0-9]{4}$/)
        .nullable(),
    isTracked: z.boolean(),
    cardId: uuidSchema.nullable(),
    operationCount: z.int().min(0),
    historyFrom: isoTimestampSchema.nullable(),
    isHistoryComplete: z.boolean(),
});
export const bankConnectionSchema = z.object({
    id: uuidSchema,
    provider: z.literal('monobank'),
    clientName: z.string().min(1),
    isConnected: z.boolean(),
    isWebhookActive: z.boolean(),
    problem: bankProblemSchema.nullable(),
    connectedAt: isoTimestampSchema,
    accounts: z.array(bankAccountSchema),
});
export const bankStateSchema = z.object({
    connection: bankConnectionSchema.nullable(),
});
export const updateBankAccountBodySchema = z
    .object({
    isTracked: z.boolean().optional(),
    cardId: uuidSchema.optional(),
})
    .refine((body) => body.isTracked !== undefined || body.cardId !== undefined, {
    message: 'name at least one field to change',
});
//# sourceMappingURL=bank.js.map